import OnboardingRia from '@advisor/models/store/onboardingRia/index';
// eslint-disable-next-line import/no-cycle
import OnboardingRiaService from '@advisor/services/OnboardingRia';
import {returnNoneApi} from '@advisor/util/returnNoneApi';
import exceptionHandler from '@advisor/util/exceptionHandler';

export const stateObj = function () {
  return new OnboardingRia();
};

export const getters = {};

export const actions = {
  async resendVerificationLink({commit}, payload) {
    try {
      const apiCall = await OnboardingRiaService.onboardingRia(payload);

      returnNoneApi(apiCall);
      commit('SET_RIA_AND_RIAUSER', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('onboardingRia.resendVerificationLink', error);

      return Promise.reject(error);
    }
  },

  async sendEmailToService(_, payload) {
    try {
      const apiCall = await OnboardingRiaService.onboardingRia(payload);

      returnNoneApi(apiCall);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('onboardingRia.sendEmailToService', error);

      return Promise.reject(error);
    }
  },

  async createRiaAndRiaUser({commit}, payload) {
    try {
      const apiCall = await OnboardingRiaService.onboardingRia(payload);

      returnNoneApi(apiCall);
      commit('SET_RIA_AND_RIAUSER', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('onboardingRia.createRiaAndRiaUser', error);

      return Promise.reject(error);
    }
  },

  async emailVerification(_, payload) {
    try {
      const response = await OnboardingRiaService.getEmailAvailability(payload);

      return response;
    } catch (error) {
      exceptionHandler.handleGenericException('onboardingRia.emailVerification', error);

      return Promise.reject(error);
    }
  },
};

export const mutations = {
  SET_RIA_AND_RIAUSER(state, payload) {
    state.onboardedRia = payload.data;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
